import React from 'react';
import { Download, Smartphone } from 'lucide-react';
import { useApi } from '../lib/api';
import { isAndroidApp } from '../lib/androidApp';
import { Button } from './ui/button';

const AndroidDownloadStatus = ({ error, loading, reload, prefix }) => <>
  <p data-testid={`${prefix}-download-${error ? 'error' : 'status'}`} role="status" className="text-sm text-slate-600">
    {error ? 'App download is temporarily unavailable.' : loading ? 'Checking Android app availability…' : 'The Android app is not available yet.'}
  </p>
  <Button data-testid={`${prefix}-download-retry`} type="button" variant="outline" disabled={loading} onClick={reload} className="mt-3 sm:mt-0 shrink-0">
    {loading ? 'Checking…' : 'Try again'}
  </Button>
</>;

export const AndroidDownload = ({ dashboard = false, prefix = 'android' }) => {
  const { data, error, loading, reload } = useApi('/android/release');
  if (isAndroidApp()) return null;
  const noticeId = `${prefix}-install-notice`;
  const available = !error && data?.available;
  return <section data-testid={`${prefix}-download-section`} aria-label="Android customer app" className={dashboard
    ? 'lg:col-span-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b border-slate-200 pb-6 min-w-0 print:hidden'
    : 'border-t border-slate-200 pt-5 mt-5 text-center print:hidden'}>
    {dashboard && <div className="min-w-0">
      {dashboard && <h2 data-testid={`${prefix}-download-title`} className="text-base font-semibold text-slate-900">MALDHOWR for Android</h2>}
      {available && <>
        {dashboard && <p data-testid={`${prefix}-download-version`} className="text-xs text-slate-500 mt-1">Version {data.version} · Android {data.minAndroidVersion}+ · {Math.ceil(data.size / 1024 / 1024)} MB</p>}
        {dashboard && <p id={noticeId} data-testid={noticeId} className="text-xs text-slate-500 mt-2">Android only · Internet access required.</p>}
      </>}
    </div>}
    {!available ? <AndroidDownloadStatus error={error} loading={loading} reload={reload} prefix={prefix} /> : <>
      <Button asChild className={`h-auto min-h-12 whitespace-normal py-3 px-4 bg-emerald-700 text-white hover:bg-emerald-800 font-semibold ${dashboard ? 'w-full sm:w-auto shrink-0' : 'w-full'}`}>
        <a data-testid={`${prefix}-download-button`} href={`${process.env.REACT_APP_BACKEND_URL}/api/android/download`} download="MALDHOWR-Customer.apk" aria-describedby={noticeId}>
          <Smartphone aria-hidden="true" /><span>Download Android App</span><Download aria-hidden="true" />
        </a>
      </Button>
      {!dashboard && <>
        <p data-testid={`${prefix}-download-version`} className="text-xs text-slate-500 mt-2">MALDHOWR {data.version} · Android {data.minAndroidVersion}+ · {Math.ceil(data.size / 1024 / 1024)} MB</p>
        <p id={noticeId} data-testid={noticeId} className="text-xs text-slate-500 mt-2">Android will ask you to allow installation. Internet access required.</p>
      </>}
    </>}
  </section>;
};